import { getQueryClient } from '@/api/queryClient';
import { type ResultOf, type VariablesOf } from '@/graphql';
import { graphql } from '@/graphql';
import logToDatadog from '@/logger/logToDatadog';
import gqlClient from '@/utils/gqlClient';

import {
  getCartIdCookie,
  invalidateCartData,
  saveCartIdCookie,
} from '../utils/cartUtils';

export const mutation = graphql(`
  mutation ChangeWarranty($cartId: String, $skuCode: String) {
    cartChangeWarranty(cartId: $cartId, warrantySkuCode: $skuCode) {
      cartId
      resultCategory
      errorCode
      invalidReason
    }
  }
`);

export type ChangeWarrantyResult = ResultOf<typeof mutation>;
export type ChangeWarrantyVariables = VariablesOf<typeof mutation>;

export function withQueryKey(vars: ChangeWarrantyVariables) {
  return {
    queryKey: ['changeWarranty', vars.cartId],
    queryFn: async () => {
      try {
        const response = await gqlClient().request(mutation, vars);
        const result = response.cartChangeWarranty;

        if (result.resultCategory !== 'success')
          throw new Error(`ChangeWarranty failed: ${result.invalidReason}`);

        if (result.cartId) {
          saveCartIdCookie(result.cartId);
        }

        invalidateCartData();

        return result;
      } catch (error) {
        logToDatadog({
          error,
          message: 'ChangeWarranty query failed',
          module: 'cart',
        });
        throw error;
      }
    },
  };
}

export async function changeWarranty(skuCode: string) {
  const cartId = getCartIdCookie();
  const queryClient = getQueryClient();

  return queryClient.fetchQuery({
    ...withQueryKey({ cartId, skuCode: skuCode || null }),
  });
}
